import { render, staticRenderFns } from "./storehome.vue?vue&type=template&id=0b8af370&scoped=true&"
import script from "./storehome.vue?vue&type=script&lang=js&"
export * from "./storehome.vue?vue&type=script&lang=js&"
import style0 from "./storehome.vue?vue&type=style&index=0&id=0b8af370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8af370",
  null
  
)

export default component.exports